<vc-button
    iconName="download"
    mode="icon-tertiary"
    [tooltip]="tooltip"
    [disabled]="disabled"
    [loading]="loading"
    (trigger)="trigger.emit()"></vc-button>
